import styled, { css } from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 16px; /* ajuda no mobile */
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  overflow: hidden; /* evita “vazar” bordas da preview */
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #eee;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  h3 {
    margin: 0;
    color: #444;
    font-size: 16px;
    font-weight: 600;
  }

  small {
    display: block;
    margin-top: 4px;
    color: #777;
    font-size: 12px;
    line-height: 1.2;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f2f2f2;
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileItem = styled.div`
  background: #f9f9f9;
  padding: 12px 16px;
  border-radius: 6px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #333;
    word-break: break-word;
  }

  span {
    font-size: 12px;
    color: #888;
    word-break: break-word;
  }
`;

export const FileActions = styled.div`
  display: flex;
  gap: 16px;

  svg {
    cursor: pointer;
    color: #6ea5ff;
  }

  svg:last-child {
    color: #e74c3c;
  }

  @media (max-width: 600px) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const PreviewContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid #eee;
  padding-top: 16px;

  iframe {
    width: 100%;
    height: 500px;
    border: none;
    border-radius: 6px;
  }

  img {
    max-width: 100%;
    max-height: 500px;
    display: block;
    margin: 0 auto;
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    iframe {
      height: 360px;
    }

    img {
      max-height: 360px;
    }
  }
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #eee;
`;

export const UploadButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  border: 1px solid #d6d9e2;
  background: #ffffff;
  color: #111827;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 700;
  cursor: pointer;

  transition: background 120ms ease, border-color 120ms ease, transform 120ms ease;

  &:hover {
    background: #f7f7fb;
    border-color: #cfd3de;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    transform: none;
  }

  svg {
    flex-shrink: 0;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const HelperText = styled.p`
  margin: 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;
`;

export const EmptyState = styled.div`
  background: #ffffff;
  border: 1px dashed #d6d9e2;
  border-radius: 12px;
  padding: 16px;
  color: #6b7280;

  p {
    margin: 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 10px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Input = styled.input`
  height: 40px;
  border-radius: 10px;
  border: 1px solid #d6d9e2;
  padding: 0 10px;
  outline: none;
  color: #111827;

  &:focus {
    border-color: #bfc6d6;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  border: 1px solid #2563eb;
  background: #2563eb;
  color: #ffffff;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const SecondaryButton = styled.button`
  border: 1px solid #d6d9e2;
  background: #ffffff;
  color: #111827;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;
`;

export const ErrorText = styled.div`
  margin-top: 8px;
  color: #b42318;
  font-size: 12px;
  font-weight: 700;
`;

export const SuccessText = styled.div`
  margin-top: 8px;
  color: #1b7a3a;
  font-size: 12px;
  font-weight: 700;
`;

export const SelectWrap = styled.div`
  position: relative;
  width: 100%;

  /* seta custom */
  &::after {
    content: "";
    position: absolute;
    right: 12px;
    top: 50%;
    width: 8px;
    height: 8px;
    border-right: 2px solid #6b7280;
    border-bottom: 2px solid #6b7280;
    transform: translateY(-60%) rotate(45deg);
    pointer-events: none;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #d6d9e2;

  padding: 0 38px 0 12px; /* espaço pra seta custom */
  outline: none;

  background: #fff;
  color: #111827;
  font-weight: 600;
  font-size: 14px;

  transition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;

  /* remove aparência padrão */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:hover {
    background: #fbfbfd;
    border-color: #c9cedb;
  }

  &:focus {
    border-color: #9aa6c1;
    box-shadow: 0 0 0 4px rgba(27, 77, 214, 0.10); /* foco bonito */
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 12px;
    color: #374151;
    font-weight: 800;
    letter-spacing: 0.2px;
  }
`;


export const SelectRoot = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 12px;
  border: 1px solid #d6d9e2;
  background: #ffffff;

  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease, background 120ms ease;

  &:hover {
    background: #fbfbfd;
    border-color: #c9cedb;
  }

  &:focus {
    outline: none;
    border-color: #9aa6c1;
    box-shadow: 0 0 0 4px rgba(27, 77, 214, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SelectValue = styled.span<{ $muted?: boolean }>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ $muted }) => ($muted ? "#6b7280" : "#111827")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SelectChevron = styled.span<{ $open?: boolean }>`
  width: 9px;
  height: 9px;
  border-right: 2px solid #6b7280;
  border-bottom: 2px solid #6b7280;
  transform: ${({ $open }) => ($open ? "rotate(-135deg)" : "rotate(45deg)")};
  transition: transform 120ms ease;
  flex-shrink: 0;
`;

export const SelectPopover = styled.div`
  position: absolute;
  z-index: 99999;
  left: 0;
  right: 0;
  margin-top: 8px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(16, 24, 40, 0.16);
  overflow: hidden;
`;

export const SelectList = styled.div`
  max-height: 240px;
  overflow: auto;
  padding: 6px;

  /* scrollbar leve */
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e5e7eb;
    border-radius: 999px;
    border: 3px solid #ffffff;
  }
`;

export const SelectOption = styled.div<{ $active?: boolean; $selected?: boolean }>`
  padding: 10px 10px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  color: #111827;

  ${({ $selected }) =>
    $selected &&
    css`
      background: #eef2ff;
      color: #1b4dd6;
    `}

  ${({ $active }) =>
    $active &&
    css`
      background: #f3f4f6;
    `}
`;

export const SelectEmpty = styled.div`
  padding: 10px 10px;
  font-size: 13px;
  color: #6b7280;
`;

export const PageShell = styled.div`
  min-height: 100vh;
  background: #f6f7fb;
  padding: 24px 16px;
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
`;
